import { Component, OnInit } from '@angular/core';
import { ClrIconModule } from "@clr/angular";
import { JsonPipe, NgIf } from "@angular/common";
import { AlertService, IAlertType, StaffStoreService, TransportStoreService } from "../../../_shared/services";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { Delivery, Personen } from "../../../_shared/interfaces";
import { OrderTransportFormComponent } from "../order-transport-form/order-transport-form.component";

import { environment as env } from "../../../../environments/environment";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-order-transport-update',
  standalone: true,
  imports: [
    ClrIconModule,
    JsonPipe,
    NgIf,
    RouterLink,
    OrderTransportFormComponent
  ],
  templateUrl: './order-transport-update.component.html',
  styleUrl: './order-transport-update.component.sass'
})
export class OrderTransportUpdateComponent implements OnInit {
  projectId: string = '';
  jobId: number = 0;
  transportId: number = 0;
  orderId: number = 0;
  transport: Delivery[] = [];
  positions: Delivery[] = [];
  person: Personen[] = [];
  loading1: boolean = true;
  loading2: boolean = true;
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';

  devMode: boolean;

  constructor(
    private transss: TransportStoreService,
    private staffss: StaffStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '');
    this.orderId = parseInt(params.get('orderid') ?? '');
    this.transportId = parseInt(params.get('transportid') ?? '');
    this.loadTransport(this.projectId, this.transportId);
    }

  loadTransport(projectId: string, transportId: number) {
    this.transss.getTransport(projectId, 0, transportId, 'all').subscribe({
      next: data1 => {
        if (!data1 || !data1.object) {
          this.alertDispatcher.show({
            message: 'Keine Transportdaten gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.transport = data1.object;
      },
      complete: () => {
        // Mitarbeiter personalisieren
        this.staffStatus(this.transport[0].employee_phm);

        this.loading1 = false;
      },
      error: () => {
        return
      }
    });
  }

  staffStatus(staffId: number){
    this.staffss.getStaffById(staffId)
      .subscribe({
        next: staff => {
          if (!staff) {
            return;
          }
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
          this.staffPhone = staff.object[0].phone;
        },
        complete: () => {
          if (this.devMode) console.log('StaffID ist ' + staffId);
        }
      })
  }
}
